import "./configs/i18n";
import "react-perfect-scrollbar/dist/css/styles.css";
import "sweetalert2/src/sweetalert2.scss";
import "./@core/scss/core.scss";
// slick carousel scss
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import * as serviceWorker from "./serviceWorker";

/* eslint-disable no-useless-escape */
import App from "./App";
import ReactDOM from "react-dom/client";

// ** Lazy load app

// TagManager.initialize(tagManagerArgs);
const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);
root.render(
    <App />
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
